import NarrativeEventContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NarrativeEventContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import AbstractCommand from "../../../core/application/AbstractCommand";
import GameEvent from "../../../core/application/GameEvent";
import SystemMessageBuilder from "../../../core/system-message/controller/SystemMessageBuilder";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import HubEvent from "../../hub/event/HubEvent";
import TransitionEvent from "../events/TransitionEvent";

export default class TransitionCommand extends AbstractCommand {
    constructor(dispatcher, variableManager, progressGameModel, saveGameService) {
        super(dispatcher);
        //TEMP, see at bottom as well:
        this._variableManager = variableManager;
        this._progressGameModel = progressGameModel;
        this._saveGameService = saveGameService;
    }

    execute(evt) {
        this.dispatch(GameEvent.PAUSE_GAME);
        this.dispatch(HubEvent.HIDE_HUB);

        const data = evt.params.data;

        /** @type {NarrativeEventContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        this._handleCloseBound = this._handleClose.bind(this);
        this._dispatcher.addEventListener(TransitionEvent.CLOSE_REQUEST, this._handleCloseBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.TRANSITION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            content: this._content,
        });
    }

    _handleClose() {
        this.dispatch(GameEvent.RESUME_GAME);
        this.dispatch(HubEvent.SHOW_HUB);

        this._dispatcher.removeEventListener(TransitionEvent.CLOSE_REQUEST, this._handleCloseBound);

        this.closeScreen(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);

        // 20231221, Reinier
        // TEMPORARY BANDAGE TO DETECT INVALID OUTCOME FOR THE 'no-epilogue bug'
        const variables = this._variableManager._variables;
        if (variables.chapter == 3 && variables.week_number >= 15) {
            // Check the 'path'
            const path = this._progressGameModel.path;
            if (!path || path.length < 3) {
                console.error(`[TransitionCommand] (Temporary code) detected invalid ProgressGameModel.path '${path}'!`);
                //TRACK IN ANALYTICS
                this.trackEvent(TrackString.EVENT_INVALID_PATH, { path });
                this.trackEvent("PATH_" + path); // extra event in case we can't easily read the event parameter 'path' (which needs configuration in GA)
                //Show error and on close, clear save game because it contains invalid data, and take user to credits
                const callback = () => {
                    this._saveGameService.clear();
                    // Go to end screen
                    this.closeScreen(SkinKeyRegistry.HUB_SCREEN_SKIN);
                    this.openScreen(SkinKeyRegistry.END_SCREEN_SKIN, {
                        animationType: AnimationFactory.FADE_IN,
                        animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                    });
                }
                const systemMessage = new SystemMessageBuilder()
                    .setTitle('Oops!')
                    .setDescription(`An error has occured. The game is unable to show the final part of the feedback.\nClick 'OK' to go to the end screen.`)
                    .addOption({ text: 'OK', callback })
                    .build();
                this.showSystemMessage(systemMessage);
            }
        }
    }
}